import Styled,{css } from 'styled-components'

export const Container = Styled.div`
 display: flex;
 justify-content: space-between;
 align-items: center;
 p {
  margin: 0
 }
`

export const Tachado = Styled.p`
 text-decoration: line-through;
 font-size: 13px;
`

export const Bold = Styled.b`
font-size: 16px;
color : var(--text-dark);
`

export const Box = Styled.div`
  span {
    font-weight: 700;
    font-size: 22px;
    word-wrap: break-word;
    color: ${props => props.theme.whitelabel.text_primary_color};
  }
  .tachado-price {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    opacity: 0.60;
    color:${props => props.theme.whitelabel.text_primary_color};
  }
  .por-price {
    font-weight: 700;
    font-size: 22px;
    word-wrap: break-word;
    color: ${props => props.theme.whitelabel.text_primary_color};
  }
  .divisor {
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: ${props => props.theme.whitelabel.text_primary_color};
    display: inline-block;
    padding: 0 10px;
    position: relative;
    z-index: 1;
  }
  .divisor::before, .divisor::after {
    content: "";
    position: absolute;
    border: 1px solid ${props => props.theme.whitelabel.text_primary_color};
    width: 15px;
    height: 0;
    z-index: -1;
    transform: rotate(90deg);
    transform-origin: center;
  }

  .divisor::before {
    top: 0;
    left: 30%;
    margin-top: -8px;
  }

  .divisor::after {
    bottom: 0;
    right: 30%;
    margin-bottom: -8px;
  }

  .divisor {
    top: calc(50% - 0.5em);
  }
`

const Row = css`
 flex-direction: row
`